import TeamImage from 'components/TeamImage';
import cn from 'classnames';
import styles from './styles/ScoreboardGame.module.scss';
import { LIVE, UPCOMING } from 'constants/GameStatuses';
import GameStatusText from '@/components/GameStatusText';
import Clickable from '../Clickable';

interface HorizontalScoreboardGameProps {
  game: {
    date: string;
    gameTeams: {
      id: string;
      isLoser: boolean;
      isTbd: boolean;
      isWinner: boolean;
      pregameStanding?: { overallRecord: string };
      scoreText?: string;
      team: {
        image?: string;
        name: string;
        mascot?: string;
      };
      teamRanking?: {
        place: number;
      };
    }[];
    genderSport: {
      name: string;
      slug: string;
    };
    longStatusText: string;
    source?: string;
    statusId: number;
    webPath: string;
  };
  showGenderSport?: boolean;
}

export default function HorizontalScoreboardGame({ game, showGenderSport }: HorizontalScoreboardGameProps) {
  const isScoreStream = game.source === 'score_stream';

  return (
    <Clickable className={styles.SBLWidgetGame} href={game.webPath} target="_blank">
      <div>
        <div className={styles.SBLWidgetGameInfo}>
          {showGenderSport && (
            <>
              <div className={styles.hideMobile}>
                <i className={`icon ${game.genderSport.slug}-icon`} />
                {game.genderSport.name}
              </div>
              {/* TODO: add genderSport.shortName property */}
              <div className={styles.hideDesktop}>{game.genderSport.name.replace('Boys', 'B.').replace('Girls', 'G.')}</div>
            </>
          )}
          <div className={cn({ [styles.SBLWidgetGameInfoLive]: game.statusId === LIVE })}>
            <GameStatusText game={game}>{game.longStatusText}</GameStatusText>
          </div>
        </div>
        <div className={styles.SBLWidgetGameTeams}>
          {game.gameTeams.map(({ id, team, scoreText, isWinner, isLoser, isTbd, pregameStanding, teamRanking }) => (
            <div
              key={id}
              className={cn(styles.SBLWidgetGameTeam, {
                [styles.SBLWidgetGameTeamWin]: isWinner && !isScoreStream,
                [styles.SBLWidgetGameTeamLoss]: isLoser && !isScoreStream
              })}
            >
              <div className={styles.SBLWidgetGameTeamImage}>
                <TeamImage alt={team.name} src={team.image} />
              </div>
              {teamRanking && <div className={styles.SBLWidgetTeamRank}>{teamRanking.place}</div>}
              {!teamRanking && <div className={styles.SBLWidgetTeamRank}></div>}
              <div className={styles.SBLWidgetGameTeamNameBlock}>
                <div>{team.name}</div>
                <div>{team.mascot}</div>
              </div>
              {game.statusId === UPCOMING ? (
                <div className={styles.SBLWidgetGameTeamRecord}>{pregameStanding && !isTbd ? pregameStanding.overallRecord : null}</div>
              ) : (
                <div className={styles.SBLWidgetGameTeamNameScore}>{isScoreStream ? '' : scoreText}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </Clickable>
  );
}
